import React from 'react'
import ActivityLog from './ActivityLog'
import ActivityLogsRecent from './ActivityLogsRecent'
import TimeActivity from './TimeActivity'
import ActivityStats from './ActivityStats'
import TopUsers from './TopUsers'
import TypeSummery from './TypeSummery'
import GeoIp from './GeoIp'
import GeoRecent from './GeoRecent'
import GeoStats from './GeoStats'
import TopCities from './TopCities'
import TopCoutries from './TopCoutries'

function ActivityLogs() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 p-6">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="mb-8">
                    <h1 className="text-4xl font-bold text-gray-900 mb-2">
                        Analytics Dashboard
                    </h1>
                    <p className="text-gray-600">
                        Comprehensive overview of user activities and geographic insights
                    </p>
                </div>

                {/* Stats Section */}
                <section className="mb-6">
                    <ActivityStats />
                </section>

                {/* Geo Stats Section */}
                <section className="mb-6">
                    <GeoStats />
                </section>

                {/* Main Content Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                    {/* Activity Type Summary with Chart */}
                    <TypeSummery />

                    {/* Time Analytics with Chart */}
                    <TimeActivity />
                </div>

                {/* Geographic Data Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                    {/* Top Countries with Chart */}
                    <TopCoutries />

                    {/* Top Users */}
                    <TopUsers />
                </div>

                {/* Top Cities - Full Width */}
                <section className="mb-6">
                    <TopCities />
                </section>

                {/* Recent Activities */}
                <section className="mb-6">
                    <ActivityLogsRecent />
                </section>

                {/* Recent Geographic Data */}
                <section className="mb-6">
                    <GeoRecent />
                </section>

                {/* Full Activity Log - Detailed Table */}
                <section className="mb-6">
                    <ActivityLog />
                </section>

                {/* Full Geographic IP Data - Detailed Table */}
                <section className="mb-6">
                    <GeoIp />
                </section>
            </div>
        </div>
    )
}

export default ActivityLogs




// import React from 'react'
// import ActivityLog from './ActivityLog'
// import ActivityLogsRecent from './ActivityLogsRecent'
// import TimeActivity from './TimeActivity'
// import ActivityStats from './ActivityStats'
// import TopUsers from './TopUsers'
// import TypeSummery from './TypeSummery'
// import GeoIp from './GeoIp'
// import GeoRecent from './GeoRecent'
// import GeoStats from './GeoStats'
// import TopCities from './TopCities'
// import TopCoutries from './TopCoutries'

// function ActivityLogs() {
//     return (
//         <>
//             <ActivityLogsRecent />
//             <ActivityLog />
//             <TimeActivity />
//             <ActivityStats />
//             <TopUsers />
//             <TypeSummery />
//             <GeoIp />
//             <GeoRecent />
//             <GeoStats />
//             <TopCities />
//             <TopCoutries />
//         </>
//     )
// }

// export default ActivityLogs
